import React from 'react';
import { IconPropTypes } from 'ggApp/types/propTypes';

const UmbrellaIcon = ({ className, color, size }) => (
    <svg
        className={className}
        width={size}
        height={size}
        viewBox="0 0 40 40"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.252 8.33333H19.0595C12.8887 8.33333 7.88614 13.5567 7.88614 20H33.4253C33.4253 13.5567 28.4229 8.33333 22.252 8.33333ZM19.0595 5C11.1255 5 4.69374 11.7157 4.69374 20V23.3333H36.6178V20C36.6178 11.7157 30.1859 5 22.252 5H19.0595Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.6581 8.33328L20.6557 8.33333L20.6534 8.33328C20.6352 8.33273 20.5574 8.33038 20.3675 8.47578C20.133 8.65542 19.7986 9.014 19.4085 9.65417C18.6152 10.9557 17.9182 12.8717 17.3509 15.0437C16.8992 16.773 16.5654 18.5225 16.3282 20H24.9832C24.7461 18.5225 24.4123 16.773 23.9606 15.0437C23.3933 12.8717 22.6963 10.9557 21.903 9.65417C21.513 9.014 21.1786 8.65542 20.944 8.47578C20.7541 8.33038 20.6763 8.33273 20.6581 8.33328ZM28.2179 20C27.4136 14.7138 25.3032 5 20.6557 5C16.0082 5 13.8979 14.7138 13.0936 20C12.7929 21.976 12.6748 23.3333 12.6748 23.3333H28.6368C28.6368 23.3333 28.5186 21.976 28.2179 20Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.0595 31.6667V20H22.252V31.6667C22.252 34.4282 20.108 36.6667 17.4634 36.6667C14.8187 36.6667 12.6748 34.4282 12.6748 31.6667V30H15.8672V31.6667C15.8672 32.5872 16.5818 33.3333 17.4634 33.3333C18.345 33.3333 19.0595 32.5872 19.0595 31.6667Z"
            fill={color}
        />
    </svg>
);

UmbrellaIcon.propTypes = {
    ...IconPropTypes,
};

UmbrellaIcon.defaultProps = {
    color: '#333333',
    className: '',
    size: 24,
};

export default UmbrellaIcon;
